import { render, staticRenderFns } from "./ThemePropCenter.vue?vue&type=template&id=2daf63af&scoped=true"
import script from "./ThemePropCenter.vue?vue&type=script&lang=js"
export * from "./ThemePropCenter.vue?vue&type=script&lang=js"
import style0 from "./ThemePropCenter.vue?vue&type=style&index=0&id=2daf63af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daf63af",
  null
  
)

export default component.exports